// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { projectOfficeManifest } from './project-office';
import { projectPortfolioManifest } from './project-portfolio';
import { projectProposalsManifest } from './project-proposals';

/** Група модулів «Проєкти» (Projects): 3 модулів. */
export const projectsGroup: IModuleGroupManifest = {
  key: 'projects',
  category: 'Projects',
  name: { en: 'Projects', uk: 'Проєкти' },
  sort: 3,
  modules: [projectOfficeManifest, projectPortfolioManifest, projectProposalsManifest],
};
